module.exports = __webpack_public_path__ + "static/media/menu_subscriptionFees_hoverAtive.9ce792cb.svg";